import styled from 'styled-components';
import { TextField } from '@mui/material';

export const StyledInput = styled(TextField)`
  // Disable arrows for number type
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
